import LangEnum from '../../../lang/LangEnum';
import PATHS from '../../../routes/routes.const';
import { ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_KEYS } from '../../accountsReceivable/filters/installmentsListFilterKeys';
import { INVOICES_FILTERS_KEYS } from '../../invoices/pages/InvoiceListPage/hooks/invoiceFilter.utils';
import { EntityConfigMap } from './entityConfig.types';

export const buildCatalogDetailRoute = (catalogId: string): string =>
  PATHS.main.catalogs.products.path.replace(':id', catalogId);

export const ENTITY_CONFIG: EntityConfigMap = {
  order: {
    label: LangEnum.GLOBAL_ORDERS,
    detail: (item) => `/orders/${item.id}`,
    list: () => '/orders',
  },
  customer: {
    label: LangEnum.GLOBAL_CUSTOMERS,
    detail: (item) => `/customers/${item.id}`,
    list: () => '/customers',
  },
  catalog: {
    label: LangEnum.GLOBAL_CATALOGS,
    detail: (item) => buildCatalogDetailRoute(item.id),
    list: () => '/catalogs',
  },
  product: {
    label: LangEnum.GLOBAL_PRODUCTS,
    detail: () => '/products',
    list: () => '/products',
  },
  invoice: {
    label: LangEnum.INVOICES_TITLE,
    detail: (item) =>
      `/invoices?${INVOICES_FILTERS_KEYS.invoiceIds}=${encodeURIComponent(item.id)}`,
    list: () => '/invoices',
  },
  accountReceivable: {
    label: (isStore) =>
      isStore ? LangEnum.ACCOUNTS_RECEIVABLE_PAYABLE_TITLE : LangEnum.ACCOUNTS_RECEIVABLE_TITLE,
    detail: (item, isStore) => {
      const path = isStore ? '/accounts-payable' : '/accounts-receivable';
      return `${path}?${ACCOUNTS_RECEIVABLE_INSTALLMENTS_LIST_FILTER_KEYS.receivableCodes}=${encodeURIComponent(item.receivableCode)}`;
    },
    list: (isStore) => (isStore ? '/accounts-payable' : '/accounts-receivable'),
  },
};
